/**
 * Creates an index generator function that yields incrementing numbers.
 * Returns a generator object that can be used with .next().value to get the next index.
 *
 * @param initial - The starting index value (default: 0)
 * @returns Generator function that yields incrementing numbers starting from initial
 *
 * @example
 * const idGenerator = indexGenerator()
 * const id1 = idGenerator.next().value // 0
 * const id2 = idGenerator.next().value // 1
 * const id3 = idGenerator.next().value // 2
 *
 * @example
 * const idGenerator = indexGenerator(10)
 * const id1 = idGenerator.next().value // 10
 * const id2 = idGenerator.next().value // 11
 */
export function* indexGenerator(initial = 0): Generator<number, never, unknown> {
    let index = initial
    while (true) {
        yield index++
    }
}
